import { useContext } from "react";
import DictionaryContext from "../Dictionary/DictionaryContext";

var useDictionary = function useDictionary() {
  return useContext(DictionaryContext);
};

export default useDictionary;